(function () {
  'use strict';
  var root = document.querySelector('[data-flp-review-stack]');
  if (!root) return;
  var track = root.querySelector('[data-flp-reviews-track]');
  var stage = root.querySelector('.flp-reviews-stage');
  var summary = root.querySelector('[data-flp-review-summary] strong');
  var summaryStars = root.querySelector('[data-flp-review-summary] span');
  var status = root.querySelector('[data-flp-review-status]');
  var retry = root.querySelector('[data-flp-review-retry]');
  var reviews = [], aggregate = null, mode = 'loading', active = 0, timer;
  function english() {
    return window.FlorameI18n ? window.FlorameI18n.isEnglish() : document.documentElement.getAttribute('lang').slice(0, 2) === 'en';
  }
  function copy(it, en) { return english() ? en : it; }
  function reviewHref() {
    return (english() ? '/en' : '') + '/pages/recensioni';
  }
  function states() {
    Array.prototype.forEach.call(track.children, function (card, index) {
      var position = (index - active + reviews.length) % reviews.length;
      var name = position === 0 ? 'is-active' : position === 1 ? 'is-next' : position === reviews.length - 1 ? 'is-prev' : 'is-hidden';
      card.className = 'flp-review-card ' + name;
      card.setAttribute('aria-hidden', position === 0 ? 'false' : 'true');
      card.tabIndex = position === 0 ? 0 : -1;
    });
  }
  root.flpStopReviewAutoplay = function () { window.clearInterval(timer); };
  root.flpReviewStep = function (direction) {
    if (!reviews.length) return;
    active = (active + direction + reviews.length) % reviews.length;
    states();
  };
  function render() {
    root.flpStopReviewAutoplay();
    track.replaceChildren();
    root.classList.toggle('is-ready', mode !== 'loading');
    root.setAttribute('data-flp-review-mode', mode);
    track.setAttribute('aria-busy', mode === 'loading' ? 'true' : 'false');
    stage.hidden = !reviews.length;
    status.hidden = !!reviews.length;
    status.textContent = mode === 'error'
      ? copy('Le recensioni non sono disponibili al momento. Riprova oppure apri tutte le recensioni.', 'Reviews are unavailable right now. Try again or open all reviews.')
      : mode === 'loading' ? copy('Caricamento recensioni…', 'Loading reviews…')
      : copy('Le prime esperienze saranno pubblicate qui.', 'The first experiences will appear here.');
    retry.hidden = mode !== 'error';
    retry.textContent = copy('Riprova', 'Try again');
    var count = Number(aggregate && aggregate.count || 0);
    var average = Number(aggregate && aggregate.average || 0);
    summaryStars.hidden = !(count > 0 && average > 0 && average <= 5);
    // The public API aggregates verified customer experiences, separately from florists and partners.
    summary.textContent = !summaryStars.hidden
      ? average.toLocaleString(english() ? 'en-GB' : 'it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '/5 · ' + count + ' ' + copy('esperienze verificate', 'verified experiences')
      : copy('Leggi le recensioni su florame.ai', 'Read florame.ai reviews');
    root.querySelector('[data-flp-review-summary]').href = reviewHref();
    summaryStars.textContent = !summaryStars.hidden ? '★'.repeat(Math.round(average)) : '';
    reviews.forEach(function (review) {
      var card = document.createElement('a');
      card.href = reviewHref();
      card.setAttribute('aria-label', copy('Leggi tutte le recensioni', 'Read all reviews'));
      var stars = document.createElement('div');
      stars.className = 'flp-review-stars';
      stars.textContent = '★'.repeat(review.rating);
      stars.setAttribute('aria-label', review.rating + copy(' stelle su 5', ' out of 5 stars'));
      var quote = document.createElement('p');
      quote.className = 'flp-review-text';
      quote.textContent = '“' + review.body + '”';
      var meta = document.createElement('div');
      meta.className = 'flp-review-meta';
      var name = document.createElement('div');
      name.className = 'flp-review-name';
      var author = document.createElement('strong');
      author.textContent = review.publicName || copy('Cliente florame.ai', 'florame.ai customer');
      author.setAttribute('translate', 'no');
      var title = document.createElement('span');
      title.className = 'flp-review-product';
      title.textContent = review.title || '';
      var badge = document.createElement('span');
      badge.className = 'flp-review-badge';
      badge.textContent = review.legacy && review.legacy.label || (review.verification && review.verification.purchaseVerified === true
        ? copy('Acquisto verificato', 'Verified purchase') : copy('Email verificata', 'Verified email'));
      name.append(author, title);
      meta.append(name, badge);
      card.append(stars, quote, meta);
      track.appendChild(card);
    });
    states();
    if (reviews.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && root.getAttribute('data-flp-review-control') !== 'manual') {
      timer = window.setInterval(function () {
        if (!document.hidden && !root.matches(':hover, :focus-within')) root.flpReviewStep(1);
      }, 4300);
    }
    if (window.FlorameI18n) window.FlorameI18n.apply(root);
  }
  async function load() {
    mode = 'loading';
    render();
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await fetch(root.getAttribute('data-flp-reviews-api') + '?limit=8&category=customer_platform', {
        mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller.signal
      });
      if (!response.ok) throw new Error('Reviews unavailable');
      var payload = await response.json();
      if (payload.success === false || !Array.isArray(payload.reviews)) throw new Error('Invalid reviews');
      aggregate = payload.aggregate || null;
      reviews = payload.reviews.filter(function (review) {
        return typeof review.body === 'string' && review.body.trim() && Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5;
      });
      mode = reviews.length ? 'trust' : 'empty';
    } catch (_) {
      mode = 'error';
    } finally {
      window.clearTimeout(timeout);
      render();
    }
  }
  retry.addEventListener('click', load);
  window.addEventListener('florame:native-language-change', function () { render(); });
  load();
})();
